<div class="continue-execution-preview">
  <div class="preview-section">
    <div class="preview-label">{{ 'julia.continuation_preview.elapsed' | translate }}:</div>
    <div class="preview-value preview-elapsed">{{ elapsedLabel }}</div>
  </div>

  <div class="preview-section" *ngIf="hasPlan">
    <div class="preview-label">{{ 'julia.continuation_preview.progress' | translate }}:</div>
    <div class="preview-value">
      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="progressPercent"></div>
      </div>
      <div class="progress-caption">
        {{ 'julia.continuation_preview.tasks_done' | translate: { done: tasksDone, total: tasksTotal } }}
      </div>
    </div>
  </div>

  <div class="preview-section" *ngIf="data.message">
    <div class="preview-label">{{ 'julia.continuation_preview.question' | translate }}:</div>
    <div class="preview-value">{{ data.message }}</div>
  </div>

  <p class="preview-hint">{{ 'julia.continuation_preview.hint' | translate }}</p>
</div>
